import {menuList} from "@/api/menu/menu.js";
import {menuStore} from "@/store/store.js";

/*获取菜单信息*/
export async function menuListHooks() {
    const res = await menuList()
    await menuStore().setMenu(res)
}
